import { applyMask } from '.';
import { cnpjMask, cpfMask } from './commonMasks';

function applyCpfCnpjMask(value?: string) {
  if (value?.length === 11) {
    return applyMask(value, cpfMask);
  }
  if (value?.length === 14) {
    return applyMask(value, cnpjMask);
  }
  return value;
}

export default applyCpfCnpjMask;
